var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){
   if(window.innerWidth < 769){
     jQuery('.payment-buttons').eq(0).before(jQuery('.shopify-payment-terms.product__policies').eq(0))
   }

var ur = window.location.href;
if(ur.includes('/product')){
  
 jQuery(document).ready(function(){
   
    
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var badgeTexts = ["Ships Worldwide*",
                  "Return Policies",
                  "Secure Checkout"];
                  var svv = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
  <path d="M5.875 9.625H7.125V5.875H5.875V9.625ZM6.5 4.625C6.67708 4.625 6.82552 4.5651 6.94531 4.44531C7.0651 4.32552 7.125 4.17708 7.125 4C7.125 3.82292 7.0651 3.67448 6.94531 3.55469C6.82552 3.4349 6.67708 3.375 6.5 3.375C6.32292 3.375 6.17448 3.4349 6.05469 3.55469C5.9349 3.67448 5.875 3.82292 5.875 4C5.875 4.17708 5.9349 4.32552 6.05469 4.44531C6.17448 4.5651 6.32292 4.625 6.5 4.625ZM6.5 12.75C5.63542 12.75 4.82292 12.5859 4.0625 12.2578C3.30208 11.9297 2.64062 11.4844 2.07812 10.9219C1.51562 10.3594 1.07031 9.69792 0.742188 8.9375C0.414062 8.17708 0.25 7.36458 0.25 6.5C0.25 5.63542 0.414062 4.82292 0.742188 4.0625C1.07031 3.30208 1.51562 2.64062 2.07812 2.07812C2.64062 1.51562 3.30208 1.07031 4.0625 0.742188C4.82292 0.414062 5.63542 0.25 6.5 0.25C7.36458 0.25 8.17708 0.414062 8.9375 0.742188C9.69792 1.07031 10.3594 1.51562 10.9219 2.07812C11.4844 2.64062 11.9297 3.30208 12.2578 4.0625C12.5859 4.82292 12.75 5.63542 12.75 6.5C12.75 7.36458 12.5859 8.17708 12.2578 8.9375C11.9297 9.69792 11.4844 10.3594 10.9219 10.9219C10.3594 11.4844 9.69792 11.9297 8.9375 12.2578C8.17708 12.5859 7.36458 12.75 6.5 12.75Z" fill="#009FB5"></path>
</svg>`
    
var popup = ["simple-shipping",   "simple-return", ""];
var imgSrcs = ['https://cdn.shopify.com/s/files/1/0569/7716/2422/files/shipping.png?v=1730717418',
              'https://cdn.shopify.com/s/files/1/0569/7716/2422/files/delivery.png?v=1730717418',
              'https://cdn.shopify.com/s/files/1/0569/7716/2422/files/secure.png?v=1730717418']
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('.product-single__form')[0];
if(document.getElementsByClassName('simple-img-container').length == 0){
 
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  var prodName = jQuery('h1.product_name').html();
  
  
}
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="simple-badge-container"><img src="'+imgSrcs[i]+'"><span class="badge'+i+'" id="'+popup[i]+'">'+badgeTexts[i]+ svv +'</span></div>';
    imgContainer.appendChild(img);
    img.className = "simple-badges-container";
           
    
}  
});
  
  
jQuery(document).ready(function(){
 var atc = 0; var timeratc = setInterval(function(){
  if(jQuery('.simple-badges').length == 0) {
  
      
  var cont = `<div class="rte">
<p><span style="font-weight:400;"><b>Warehouses & Fulfillment</b>&nbsp;</span></p>
<ul>
<li style="font-weight:400;"><span style="font-weight:400;">We ship from warehouses in the US, Canada, and UK/EU. Orders within these regions are typically fulfilled locally.</span></li>
<li style="font-weight:400;"><span style="font-weight:400;">Orders outside these areas ship from the US warehouse.</span></li>
<li style="font-weight:400;"><span style="font-weight:400;">Some products are only available from our US location and may require international shipping.</span></li>
<li style="font-weight:400;"><span style="font-weight:400;">We currently <i>do not</i> ship to: Africa, South America, the Middle East, Central Asia (e.g., Kazakhstan, Uzbekistan), or Eastern Europe (e.g., Russia, Ukraine, Belarus).</span></li>
</ul>
    
<p><span style="font-weight:400;"><b>Estimated Shipping Times</b>&nbsp;</span></p>
<ul>
<li style="font-weight:400;"><span style="font-weight:400;"><b>Domestic:</b> Ships in ~5–7 business days</span></li>
<li style="font-weight:400;"><span style="font-weight:400;"><b>International:</b> Ships in ~7–10 business days</span></li>
<li style="font-weight:400;"><span style="font-weight:400;"><b>Preorders:</b> Entire order (including non-preorder items) ship when preorder items are ready</span></li>
</ul>
<p><span style="font-weight:400;"><i>Shipping times are estimates. Contact us at <a href="mailto:info@magpiegames.com" target="_blank">info@magpiegames.com</a> if you haven’t received confirmation after 10 business days.</i></span></p>

<p><span style="font-weight:400;"><b>Other Important Shipping Info</b>&nbsp;</span></p>
<ul>
<li style="font-weight:400;"><span style="font-weight:400;"><b>No cancellations</b> once checkout is complete.</span></li>
<li style="font-weight:400;"><span style="font-weight:400;"><b>Entered the wrong address?</b> We’ll try to help, but reshipping costs are on you.</span></li>
<li style="font-weight:400;"><span style="font-weight:400;"><b>Customs and taxes</b> are your responsibility and vary by region</span></li>
</ul>
<p><span style="font-weight:400;">To view our full policies, <a href="https://magpiegames.com/policies/refund-policy" target="_blank">click here</a>.</span></p>
    </div>`;
  jQuery('body').append(jQuery(`<div class="simple-popup simple-shipping-popup">
  <div class="popup-content">
    <div class="popup-title">Shipping Policy <span class="simple-close">×</span></div>
    <div class="popup-p">
      <div class="popup-contentt">
      `+cont+`
      </div>
    </div>
  </div>
</div>`))
var cont = `    <div>
<p><span style="font-weight:400;">We're a small-but-mighty team committed to customer care. Here's what you need to know:</span></p>
<ul>
<li style="font-weight:400;">
<span style="font-weight:400;"><b>Damaged, missing, or incorrect item?</b> Report within 3 business days with photos and we’ll make it right.</span>
</li>
<li style="font-weight:400;"><span style="font-weight:400;"><b>Lost in transit?</b> File a claim within 14 days of last tracking update.</span></li>
<li style="font-weight:400;"><span style="font-weight:400;"><b>Didn’t get your order?</b> We’ll help resolve it, but can’t cover issues from incorrect addresses.</span></li>
<li style="font-weight:400;"><span style="font-weight:400;"><b>Changed your mind?</b> Returns aren't accepted unless there's an exception.</span></li>
<li style="font-weight:400;"><span style="font-weight:400;"><b>Preorders ship when ready.</b> Mixed orders (preorder + non-preorder) ship when preorder items do.</span></li>
<li style="font-weight:400;"><span style="font-weight:400;"><b>Want extra peace of mind?</b> Add Premium Protection Insurance at checkout for extended claims windows and up to two free reshipments* <i>(see full policies for details)</i>.</span></li>
</ul>
<p><span style="font-weight:400;">And remember to <b>be kind</b>. We won’t tolerate rude or abusive behavior toward our team.</span></p>
<p><span style="font-weight:400;">To view our full policies, <a href="https://magpiegames.com/policies/refund-policy" target="_blank"><u>click here</u></a>. To file a claim, <a href="https://magpiegames.com/pages/file-a-claim" target="_blank"><u>click here</u></a>.</span></p>
</div>
`;
     jQuery('body').append(jQuery(`<div class="simple-popup simple-return-popup">
  <div class="popup-content">
    <div class="popup-title">Return Policy <span class="simple-close">×</span></div>
    <div class="popup-p">
      <div class="popup-contentt">
      `+cont+`
      </div>
    </div>
  </div>
</div>`))
    
  jQuery('#simple-shipping').click(function(e){
  e.stopPropagation();
  jQuery('.simple-shipping-popup').eq(0).addClass('open')
jQuery('.product_infos').addClass('show-popup');
  });   
  
        jQuery('#simple-return').click(function(e){
  e.stopPropagation();
  jQuery('.simple-return-popup').eq(0).addClass('open')
jQuery('.product_infos').addClass('show-popup');
  });   
 jQuery('span.simple-close').click(function(){
  jQuery(this).parent().parent().parent().removeClass('open')
}); 
    
    jQuery('.simple-popup').click(function(event){
  event.stopPropagation();
});
   jQuery(window).click(function() {
     if(jQuery('body > .open').length){
       jQuery('span.simple-close').click();
  jQuery('.product_infos').removeClass('show-popup');
     }
  
});
clearInterval(timeratc);}if( atc > 200){clearInterval(timeratc);}atc++;}, 50);
});    
  
}
  
}); 
}